import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationComponent = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const createPageArray = () => {
    const pages = [];
    const delta = 2;

    const range = [];
    for (
      let i = Math.max(2, page - delta);
      i <= Math.min(totalPages - 1, page + delta);
      i++
    ) {
      range.push(i);
    }

    const withDots = (value, pair) =>
      value - pair[1] === 1 ? [pair[1]] : [pair[1], "..."];

    let result = [1];
    if (range[0] > 2)
      result = [...result, ...withDots(range[0], [null, range[0]])];
    result = [...result, ...range];
    if (range[range.length - 1] < totalPages - 1)
      result = [
        ...result,
        ...withDots(totalPages, [range[range.length - 1], totalPages]),
      ];
    else if (totalPages !== 1) result.push(totalPages);

    return result;
  };

  const pageArray = createPageArray();

  return (
    <Pagination className="justify-content-center">
      <PaginationItem disabled={page <= 1}>
        <PaginationLink previous onClick={() => onPageChange(page - 1)} />
      </PaginationItem>

      {pageArray.map((p, idx) =>
        p === "..." ? (
          <PaginationItem key={idx} disabled>
            <PaginationLink href="#" onClick={(e) => e.preventDefault()}>
              ...
            </PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem key={idx} active={page === p}>
            <PaginationLink onClick={() => onPageChange(p)}>{p}</PaginationLink>
          </PaginationItem>
        )
      )}

      <PaginationItem disabled={page >= totalPages}>
        <PaginationLink next onClick={() => onPageChange(page + 1)} />
      </PaginationItem>
    </Pagination>
  );
};

export default PaginationComponent;
